"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToDoList = ToDoList;
exports.ToDoListItem = ToDoListItem;
exports.ToDoListItemLeft = ToDoListItemLeft;
exports.ToDoListItemRight = ToDoListItemRight;

var _react = _interopRequireDefault(require("react"));

require("./ToDoList.css");

var _Colors = _interopRequireDefault(require("../../Basic/Colors/Colors"));

var _Paragraph = _interopRequireDefault(require("../../Typography/Paragraph/Paragraph"));

var _excluded = ["children", "className"],
    _excluded2 = ["color", "onClick", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * @visibleName ToDoList
 */
function ToDoList(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement("ul", _extends({
    className: "to-do-list ".concat(className)
  }, rest), children);
}

function ToDoListItem(_ref2) {
  var color = _ref2.color,
      onClick = _ref2.onClick,
      children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/_react.default.createElement("li", _extends({
    className: "to-do-item",
    style: {
      borderLeftColor: ToDoList.colors[color],
      cursor: !!onClick && 'pointer'
    },
    onClick: onClick
  }, rest), /*#__PURE__*/_react.default.createElement("div", null, children));
}

;

function ToDoListItemLeft(_ref3) {
  var primary = _ref3.primary,
      secondary = _ref3.secondary;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "to-do-item-left-container"
  }, /*#__PURE__*/_react.default.createElement(_Paragraph.default, {
    fontSize: "14"
  }, secondary), /*#__PURE__*/_react.default.createElement(_Paragraph.default, {
    fontSize: "16B"
  }, primary));
}

;

function ToDoListItemRight(_ref4) {
  var primary = _ref4.primary,
      secondary = _ref4.secondary;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "to-do-item-right-container"
  }, /*#__PURE__*/_react.default.createElement(_Paragraph.default, {
    fontSize: "14"
  }, secondary), /*#__PURE__*/_react.default.createElement(_Paragraph.default, {
    fontSize: "16"
  }, primary));
}

ToDoList.colors = {
  red: _Colors.default.hapumarjapuu,
  orange: _Colors.default.loojang,
  blue: _Colors.default.sininevaal
};